import { Icon, Tooltip } from "@shopify/polaris"
import { ListMajor, StoreMajor } from "@shopify/polaris-icons"
import React, { useState } from "react"
import ShopifyLogo from "../../assets/shopify-logo.svg"
import { useTranslation } from "react-i18next"

export const ImportModeSelector = ({ importMode, setImportMode, loading }) => {
	const [hoveringStoreUrlButton, setHoveringStoreUrlButton] = useState(false)
	const [hoveringMultilinkButton, setHoveringMultilinkButton] =
		useState(false)
	const { t } = useTranslation()

	const onChange = (value) => {
		if (loading) return
		setImportMode(value)
	}

	return (
		<div
			style={{
				margin: "0rem 1rem 1.1rem 0.1rem",
				display: "flex",
				gap: "0.5rem",
			}}
		>
			<Tooltip
				content={
					<div>
						<div
							style={{
								padding: "0.4rem 0.7rem",
								borderBottom: "1px solid #eee",
							}}
						>
							{t("multiple.platforms_supported")}
						</div>
						<div
							style={{
								padding: "0.7rem",
								display: "flex",
								gap: "0.2rem",
								alignItems: "center",
							}}
						>
							<img
								src={ShopifyLogo}
								style={{ height: "1.25rem", width: "1.25rem" }}
							/>
							<span style={{ fontSize: "0.9rem" }}>
								{t("multiple.shopify_stores_and_collections")}
							</span>
						</div>
					</div>
				}
				preferredPosition="above"
			>
				<div
					style={{
						display: "flex",
						gap: "0.3rem",
						cursor: "pointer",
						padding: "0.2rem 0.3rem",
						background:
							hoveringStoreUrlButton && importMode !== "storeUrl"
								? "#ddd"
								: "",
						borderRadius:
							importMode === "storeUrl"
								? "0.3125rem 0.3125rem 0rem 0rem"
								: "0.3125rem",
						borderBottom:
							importMode === "storeUrl"
								? "0.125rem solid #3e72ff"
								: "",
					}}
					onMouseEnter={() => setHoveringStoreUrlButton(true)}
					onMouseLeave={() => setHoveringStoreUrlButton(false)}
					onClick={() => onChange("storeUrl")}
				>
					<div
						style={{
							fill:
								importMode === "storeUrl" ? "#3e72ff" : "#777",
						}}
					>
						<Icon source={StoreMajor} />
					</div>
					<div
						style={{
							fontSize: "0.9rem",
							color:
								importMode === "storeUrl" ? "#3e72ff" : "#555",
						}}
					>
						{t("multiple.store_or_collection")}
					</div>
				</div>
			</Tooltip>

			<Tooltip
				content={
					<div>
						<div
							style={{
								padding: "0.4rem 0.7rem",
								borderBottom: "1px solid #eee",
							}}
						>
							{t("multiple.platforms_supported")}
						</div>
						<div
							style={{
								padding: "0.7rem",
								display: "flex",
								gap: "0.2rem",
								alignItems: "center",
							}}
						>
							<img
								src={ShopifyLogo}
								style={{ height: "1.25rem", width: "1.25rem" }}
							/>
							<span style={{ fontSize: "0.9rem" }}>
								{t("multiple.single_shopify_product")}
							</span>
						</div>
					</div>
				}
				preferredPosition="above"
			>
				<div
					style={{
						display: "flex",
						gap: "0.3rem",
						cursor: "pointer",
						padding: "0.2rem 0.3rem",
						background:
							hoveringMultilinkButton &&
							importMode !== "multilink"
								? "#ddd"
								: "",
						borderRadius:
							importMode === "multilink"
								? "5px 5px 0px 0px"
								: "5px",
						borderBottom:
							importMode === "multilink"
								? "2px solid #3e72ff"
								: "",
					}}
					onMouseEnter={() => setHoveringMultilinkButton(true)}
					onMouseLeave={() => setHoveringMultilinkButton(false)}
					onClick={() => onChange("multilink")}
				>
					<div
						style={{
							fill:
								importMode === "multilink" ? "#3e72ff" : "#777",
						}}
					>
						<Icon source={ListMajor} />
					</div>
					<div
						style={{
							fontSize: "0.9rem",
							color:
								importMode === "multilink" ? "#3e72ff" : "#555",
						}}
					>
						{t("multiple.multiple_product_links")}
					</div>
				</div>
			</Tooltip>
		</div>
	)
}
